// Simple event emitter shared between MainMenuMobile and ProfileMenu
// to coordinate collapse state without $root.$on() (which was removed in Vue 3)
type EventHandler = (payload: unknown) => void

const listeners: Record<string, Array<EventHandler>> = {}

export const emitter = {
  on(event: string, handler: EventHandler): void {
    if (!listeners[event]) listeners[event] = []
    listeners[event].push(handler as EventHandler)
  },
  off(event: string, handler: EventHandler): void {
    if (!listeners[event]) return
    listeners[event] = listeners[event].filter(h => h !== (handler as EventHandler))
  },
  clear(event: string): void {
    listeners[event] = []
  },
  emit(event: string, payload?: unknown): void {
    if (!listeners[event]) return
    listeners[event].forEach(h => h(payload as unknown))
  }
}
